import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { AnnualTurnoverJson } from "../../../DynamicFormsJson/MastersJSON/annualTurnover";
import { getAnnualTurnover } from "../../../Slice/annualTurnover.slice";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { withRouter } from "../../../components/withRouter";
import { typeOfBusinessColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { apiPost } from "../../../utils/api_service";
import endpoint from "../../../config/endpoints";
import { statusmsg } from "../../../config/messageconstant";
class AnnualTurnoverList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {},
        };
    }


    onChangeStatus = (rowData) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {
            let status = "";
            if (rowData.isActive == 0) {
                status = 1;
            } else {
                status = 0;
            }
            showLoador({ loador: true });
            apiPost({
                url: endpoint.annualTurnover + "/update-is-active?id=" + rowData.id +
                    "&status=" + status,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (success) {
                    showNotification({ msg: statusmsg });
                    window.location.reload();
                }
            });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }

    };


    render() {
        const { annualTurnoverList, getAnnualTurnover } = this.props;
        const { dynamicMasterData } = this.state;
        return (
            <>
                <DynamicMainScreen
                    dynamicMasterData={dynamicMasterData}
                    formPath={AnnualTurnoverJson.formPath}
                    fieldMeta={AnnualTurnoverJson.fieldMeta}
                    screenTitle={AnnualTurnoverJson.screenTitle}
                    showPdfDownload={false}
                    showExcelDownload={false}
                    showExtension={false}
                    pdfFileName={false}
                    excelFileName={AnnualTurnoverJson.excelFileName}
                    showAddButton={AnnualTurnoverJson.showAddButton}
                    tableColumnsToFilter={AnnualTurnoverJson.tableColumnsToFilter}
                    tableColumns={typeOfBusinessColumns}
                    tableData={annualTurnoverList?.annualTurnover}
                    getTableData={getAnnualTurnover}
                    apiBaseURL={AnnualTurnoverJson.apiBaseURL}
                    baseIdColumn={AnnualTurnoverJson.baseIdColumn}
                    showDeleteIcon={true}
                    isActiveURLFalse={true}
                    isActiveURLFalseMethod={this.onChangeStatus}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    annualTurnoverList: state.annualTurnover,
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getAnnualTurnover,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(AnnualTurnoverList);
